export default [
    {
        icon: 'ni ni-badge',
        action: 'show',
        title: 'Просмотр',
        color: 'black',
        method: 'goToItem',
    },
];
